import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';

import './../fields.css';

class TextAreaField extends React.Component {
    render() {
        const {
            input,
            placeholder,
            disabled,
            intl,
            hideErrors,
            meta: { touched, error, warning },
            rows
        } = this.props;
        let placeholderContent = typeof placeholder === 'string' ? placeholder : intl.formatMessage(placeholder);

        return (
            <div className="text-area-field">
                {input.value && <div className="field-placeholder">{placeholderContent}</div>}
                <textarea rows={rows} {...input} placeholder={placeholderContent} disabled={disabled} autoComplete="off" autoCorrect="off" />
                {hideErrors === undefined && <span className="validation-message">{touched && (error || warning)}</span>}
            </div>
        );
    }
}

TextAreaField.defaultProps = {
    placeholder: '',
    type: '',
    meta: {},
    input: {},
    rows: 4
};

TextAreaField.propTypes = {
    placeholder: PropTypes.any,
    type: PropTypes.string,
    meta: PropTypes.object,
    input: PropTypes.object,
    rows: PropTypes.number
};

export default injectIntl(TextAreaField);



// WEBPACK FOOTER //
// ./src/components/fields/area/index.jsx